import { render, staticRenderFns } from "./responsiveHeader.vue?vue&type=template&id=c072f5d2&scoped=true&"
import script from "./responsiveHeader.vue?vue&type=script&lang=js&"
export * from "./responsiveHeader.vue?vue&type=script&lang=js&"
import style0 from "./responsiveHeader.vue?vue&type=style&index=0&id=c072f5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c072f5d2",
  null
  
)

export default component.exports